import { DateTime } from 'luxon'
export default {
  install(Vue) {
    Vue.prototype.$DateTime = DateTime
  },
}
